// frontend/src/features/workflows/components/AllRunsTable.jsx

import React from 'react';
import {
  getRelationshipTypeLabel,
  getRunSourceRunId,
} from '../utils/derivedRunDraft';
import { formatRunChangeSummary } from '../utils/runFormatting';
import { RunInputFiles } from './RunInputFiles';

export function AllRunsTable({ runs, onView, onCancel, onRetry }) {
  return (
    <div
      className="
        bg-panel rounded-2xl shadow-soft overflow-hidden
        border border-secondary/20
      "
    >
      {/* Scrollable table with sticky header */}
      <div className="max-h-[50vh] overflow-y-auto">
        <table className="w-full table-fixed border-collapse">
          <thead className="bg-secondary sticky top-0">
            <tr>
              <th className="w-1/5 px-6 py-3 text-left text-panel uppercase text-xs">
                Workflow
              </th>
              <th className="w-2/5 px-6 py-3 text-left text-panel uppercase text-xs">
                Run
              </th>
              <th className="w-1/5 px-6 py-3 text-left text-panel uppercase text-xs">
                Started
              </th>
              <th className="w-1/5 px-6 py-3 text-left text-panel uppercase text-xs">
                Status
              </th>
              <th className="w-1/5 px-6 py-3 text-left text-panel uppercase text-xs">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-primary/20">
            {runs.map(r => {
              const status = (r.status || 'completed').toLowerCase();
              const sourceRunId = getRunSourceRunId(r);
              let badgeBg = 'bg-green-100';
              let badgeText = 'text-green-600';
              let badgeLabel = status.charAt(0).toUpperCase() + status.slice(1);

              if (status === 'running' || status === 'pending') {
                badgeBg = 'bg-accent/20';
                badgeText = 'text-accent';
                badgeLabel = status === 'pending' ? 'Pending' : 'Running';
              } else if (status === 'failed' || status === 'error') {
                badgeBg = 'bg-red-100';
                badgeText = 'text-red-600';
                badgeLabel = 'Failed';
              }

              const started = r.startedAt
                ? new Date(r.startedAt).toLocaleString()
                : '—';

              return (
                <tr key={r.id} className="bg-white">
                  <td className="px-6 py-4 text-body">
                    <div className="font-medium">{r.workflowTitle}</div>
                    <div className="text-xs text-slate-500">
                      {getRelationshipTypeLabel(r.relationship_type)}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-body">
                    <div className="font-medium">{r.label}</div>
                    <RunInputFiles inputFiles={r.input_files} />
                    <div className="text-xs text-slate-500">
                      {formatRunChangeSummary(r)}
                    </div>
                    {sourceRunId && (
                      <div className="text-xs text-slate-500">
                        Source run: {sourceRunId}
                      </div>
                    )}
                  </td>
                  <td className="px-6 py-4 text-body">{started}</td>
                  <td className="px-6 py-4">
                    <span
                      className={`
                        inline-block px-3 py-1 rounded-full text-xs font-medium
                        ${badgeBg} ${badgeText}
                      `}
                    >
                      {badgeLabel}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => onView(r)}
                      className="text-primary hover:underline"
                    >
                      Open in batch
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
